import View from "../../../Nav/Js/views/PubliVisualsView";
import components from "./components.js";
components.define("js-PubliVisuals", View);